import type { Magento2_CountryCodeEnum } from '@__generated__/globalTypes';

// biome-ignore lint/correctness/noUnusedImports: Biome bug fixed after release https://github.com/biomejs/biome/pull/4547
import type { AddressFormFields } from './Address.constants';

export type AddressType = Omit<Nullable<AddressFormValues>, 'street'> & {
  street: (string | null)[] | null;
};

export type AddressFormValues = {
  /*
   * Designed for Magento2_CartAddressInput
   * If used for Magento2_CustomerAddressInput `region` needs to be mapped
   * as done in mapToNewCustomerAddress
   */
  __typename?: string;
  id?: number | null;
  firstname: string;
  lastname: string;
  country_code: Magento2_CountryCodeEnum;
  street: string[];
  'street[0]'?: string;
  postcode: string;
  city: string;
  telephone?: string;
  region_id?: number;
  company?: string;
  vat_id?: string;
};

export enum FormVisibilityState {
  HIDDEN = 'hidden',
  SHOWN = 'shown',
}

export type AddressFormState = {
  billing?: AddressFormValues;
  shipping?: AddressFormValues;
  selected?: AddressFormValues;
  edit?: AddressFormValues;
  sameAsShipping: boolean;
  [AddressFormFields.FormVisibility]:
    | FormVisibilityState.HIDDEN
    | FormVisibilityState.SHOWN;
};
